import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  type NotificationSettings,
  NotificationSettingsResponseSchema,
  type NotificationTestRequest,
} from '@vision360/contracts';
import { useApi } from '@/lib/auth/session-context';

/** Notification settings and the Telegram test over the API (TechSpec §12.3, step 32). */

export const NOTIFICATION_SETTINGS_KEY = ['settings', 'notifications'] as const;

export function useNotificationSettings() {
  const api = useApi();
  return useQuery({
    queryKey: NOTIFICATION_SETTINGS_KEY,
    queryFn: ({ signal }) =>
      api.request('/api/v1/settings/notifications', {
        schema: NotificationSettingsResponseSchema,
        signal,
      }),
  });
}

export function useSaveNotificationSettings() {
  const api = useApi();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (settings: NotificationSettings) =>
      api.request('/api/v1/settings/notifications', {
        method: 'PUT',
        body: settings,
        schema: NotificationSettingsResponseSchema,
      }),
    onSuccess: (response) => queryClient.setQueryData(NOTIFICATION_SETTINGS_KEY, response),
  });
}

export function useSendTestNotification() {
  const api = useApi();
  return useMutation({
    mutationFn: (body: NotificationTestRequest) =>
      api.request('/api/v1/notifications/test', { method: 'POST', body }),
  });
}
